/**
 * Ortam değişkenleri.
 *
 * Eksik yapılandırma modül yüklenirken patlar — uygulamanın açılıp ilk istekte
 * anlaşılmaz bir ağ hatası vermesindense, açılışta ne yapılması gerektiğini
 * söyleyen bir mesajla durması yeğ.
 */

function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === "") {
    throw new Error(
      `${name} tanımlı değil. web/.env.example dosyasını .env.local olarak ` +
        `kopyalayıp Supabase panelindeki (Project Settings → API) değerlerle doldurun.`,
    );
  }

  return value.trim();
}

export const env = {
  supabaseUrl: required("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required("VITE_SUPABASE_ANON_KEY", import.meta.env.VITE_SUPABASE_ANON_KEY),
  isDev: import.meta.env.DEV,
} as const;
